import dayjs from 'dayjs'
import Lottie from 'lottie-web'
import { useEffect, useRef } from 'react'
import SearchingLottieFile from '~assets/animations/searching.json'
import Icon from '~components/ui/icon'

const generateEstimatedTime = (createdAt: string) => {
  const min = 27
  const max = 31
  return dayjs(createdAt)
    .add(Math.floor(Math.random() * (max - min + 1) + min), 'minutes')
    .format('HH:mm A')
}

export const WaitingAnswerLottieBlock = ({ createdAt }: { createdAt: string }) => {
  const searchingLottieRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const instance = Lottie.loadAnimation({
      container: searchingLottieRef.current as Element,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: SearchingLottieFile,
    })

    return () => instance.destroy()
  }, [])

  return (
    <div className="flex flex-col items-center justify-center px-5 py-20 lg:mb-1 lg:mt-5">
      <div ref={searchingLottieRef} className="h-[74px] w-full" />
      <div className="mb-3 mt-5 text-primary-600 text-title-1 lg:text-headline-5 dark:text-gray-100">
        Waiting for a Vet’s answer...
      </div>
      <p className="text-center text-primary-600 text-body-2 lg:whitespace-pre-line dark:text-gray-500">
        {
          'Your questions will be reviewed shortly.\nYou will get notified as soon as the answers are ready.'
        }
      </p>
      <div className="mt-6 flex w-full flex-col hs:flex-row items-center justify-center flex-gap-y-1 hs:flex-gap-y-0 hs:flex-gap-x-3 rounded-lg p-3">
        <p className="text-primary-600 text-body-2 dark:text-white">Estimated response time</p>
        <div className="flex flex-row justify-center flex-gap-x-1">
          <Icon name="alarm" className="size-6 fill-primary-500 dark:fill-white" />
          <p className="text-primary-500 text-body-1 dark:text-white">
            {generateEstimatedTime(createdAt)}
          </p>
        </div>
      </div>
    </div>
  )
}
